import store from '@/store';
import { routeMap } from '@/config/routeMap';
import util from './util';
function initMenu (router, menu) {
  if (menu.length == 0) return;
  const originMenu = menu.map(oMenu => {
    const { funcMenuId, ...rest } = oMenu;
    return {
      ...rest,
      id: funcMenuId
    };
  });
  const treeMenu = util.arrangeData(originMenu);
  const menus = formatRouters(treeMenu);
  menus.sort((a, b) => a.sort - b.sort);
  const unfound = { path: '*', redirect: '/404', hidden: true };
  menus.push(unfound);
  router.addRoutes(menus);
  store.commit('ADD_ROUTERS', menus);
};
function formatRouters (aMenu) {
  const aRouter = [];
  aMenu.forEach(oMenu => {
    const { menuCode, menuName, children, menuType, menuSortNum } = oMenu;
    const maps = routeMap[menuCode];
    if (maps) {
      const oRouter = {
        // path: maps.fatherPath ? `/${maps.fatherPath}/${menuCode}` : `/${menuCode}`,
        path: `/${menuCode}`,
        component: maps.component,
        name: menuName,
        meta: { ...maps.meta, title: menuName, icon: maps.icon, hideInMenu: menuType === 2 },
        children: children && children.length > 0 ? formatRouters(children) : [],
        sort: maps.sort || menuSortNum
      };
      aRouter.unshift(oRouter);
    }
  });
  return aRouter;
}

export { initMenu };
